require('./es6.array.iterator');
var Iterators = require('./$.iterators');
Iterators.NodeList = Iterators.HTMLCollection = Iterators.Array;


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/library/modules/web.dom.iterable.js
 ** module id = 30
 ** module chunks = 2
 **/